import type { EntityTemplateListItem } from '@/services/core/entityTemplateApi';

/**
 * Pick the default template to auto-apply when the user opens "New" (entity-templates spec §8/§9).
 *
 * Precedence: the caller's own USER default wins over an ORG_UNIT default — a personal default
 * overrides a shared one. Returns `null` when no default exists (→ open a blank create form).
 *
 * The list passed in is already scope-filtered to the caller and ordered by the API
 * (IsDefault desc, then Name), so among same-visibility defaults the first is taken. Resolving
 * the *nearest* org unit up the hierarchy (when several ORG_UNIT defaults are visible) is a
 * Phase-2 concern that belongs server-side; this client picker honors only the visibility tier.
 */
export function pickDefaultTemplate(
  templates: EntityTemplateListItem[],
): EntityTemplateListItem | null {
  const defaults = templates.filter((t) => t.isDefault);
  if (defaults.length === 0) return null;
  return (
    defaults.find((t) => t.visibility === 'USER') ??
    defaults.find((t) => t.visibility === 'ORG_UNIT') ??
    defaults[0]
  );
}
